// extracted by mini-css-extract-plugin
export default {"container":"opX0Yv","ballOne":"NIoHNz","ballTwo":"WpnoV5","ballThree":"fsOL9W","bouncedelay":"cs2GRI"};